export const sendData = (type, data) => ({
  type,
  data,
});
